<template>
  <div class="event-item">
    <span :style="{ backgroundColor: color }" class="event-item__bullet"></span>
    <div class="event-item__event" @click="editEvent">
      <span class="event__date">{{ start }} - {{ end }}</span>
      <span class="event__title">{{ title }}</span>
      <span class="event__description">
        {{ description | truncate(40, "...") }}
      </span>
    </div>
    <div class="event-item__settings">
      <i @click="editEvent" v-tooltip="'Muokkaa'" class="icon icon--edit"></i>
      <i @click="deleteEvent" v-tooltip="'Poista'" class="icon icon--x"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventItem",
  props: {
    start: {
      type: String,
      default: null,
    },
    end: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  filters: {
    truncate: function(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
  methods: {
    editEvent() {
      this.$emit("edit");
    },
    deleteEvent() {
      this.$emit("delete");
    },
  },
};
</script>

<style lang="scss">
.event-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  margin: 0.5em 0;
  padding-bottom: 2.5px;
  font-size: 90%;
  overflow: hidden;
  transition: $transition;
  border-bottom: 1px solid $whitegray;
  cursor: pointer;
  &:hover {
    color: $lightred;
    transition: $transition;
    .event-item__title {
      color: $lightred;
    }
    .event-item__settings {
      @include bp(md) {
        transform: translateX(0);
        transition: $transition;
      }
    }
  }
  &__bullet {
    position: relative;
    top: 5px;
    margin-right: 1em;
    margin-bottom: auto;
    background: $blue;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  &__event {
    display: flex;
    flex-direction: column;
  }
  &__settings {
    margin-left: auto;
    @include bp(md) {
      transform: translateX(5em);
      transition: $transition;
    }
    i {
      cursor: pointer;
    }
  }

  .event {
    &__description {
      color: #aaa;
    }
  }
}
</style>
